// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2jzdg","select":"Header_select__2iaMz","clinic":"Header_clinic__1BW9g"};